import { apiClient } from "./client";

export async function getHermesInsight({
  id,
  dateFrom,
  dateTo,
  groupByRestaurant,
  restaurantGroup,
  force = false,
}) {
  const res = await apiClient.post("/dash/hermes/insight", {
    id,
    dateFrom,
    dateTo,
    groupByRestaurant,
    restaurantGroup,
    force,
  });
  return res.data;
}

export async function getWaiterInsight({
  id,
  dateFrom,
  dateTo,
  groupByRestaurant,
  restaurantGroup,
  force = false,
}) {
  const res = await apiClient.post("/dash/hermes/waiter-insight", {
    id,
    dateFrom,
    dateTo,
    groupByRestaurant,
    restaurantGroup,
    force,
  });
  return res.data;
}

export async function getWarehouseInsight({ id, force = false }) {
  const res = await apiClient.post("/dash/hermes/warehouse-insight", { id, force });
  return res.data;
}

export async function getMenuInsight({
  id,
  dateFrom,
  dateTo,
  groupByRestaurant,
  restaurantGroup,
  force = false,
}) {
  const res = await apiClient.post("/dash/hermes/menu-insight", {
    id,
    dateFrom,
    dateTo,
    groupByRestaurant,
    restaurantGroup,
    force,
  });
  return res.data;
}
